export default class ProducaoSettings {
  production = true;

  stage = 'producao';

  // APR-2965 — inversão A2: cidade fora do citiesWhitelist é resolvida pela API
  // (cities/identity + auth-config.connection). Ligar junto com o aprova-frontend.
  dynamicTenantResolution = true;

  // APR-3501 — título da aba com o Nome do sistema da cidade (Identidade & Marca).
  // Rollout controlado: só as identidades listadas. Para abrir a todas, `true`.
  brandedPageTitle = ['niteroirj'];

  citiesWhitelist = [
    {
      name: 'Chapecó - SC',
      identity: 'chapecosc',
      connection: 'OneDocChapeco',
    },
    {
      name: 'Barretos - SP',
      identity: 'barretossp',
      connection: 'BarretosSP',
    },
    {
      name: 'Xangri-lá - RS',
      identity: 'xangrilars',
      connection: 'Xangrila',
    },
    {
      name: 'Modelo - AD',
      identity: 'modeload',
      connection: 'ModeloAD',
    },
    {
      name: 'Curitibanos - SC',
      identity: 'curitibanossc',
      connection: 'CuritibanosSC',
    },
    {
      name: 'Cascavel - PR',
      identity: 'cascavelpr',
      connection: 'CascavelPR',
    },
    {
      name: 'Mogi das Cruzes - SP',
      identity: 'mogidascruzessp',
      connection: 'MogiDasCruzesSP',
    },
    {
      name: 'Mafra - SC',
      identity: 'mafrasc',
      connection: 'MafraSC',
    },
    {
      name: "Santa Bárbara D'Oeste - SP",
      identity: 'santabarbaradoestesp',
      connection: 'SantaBarbaraDOesteSP',
    },
    {
      name: 'Itajaí - SC',
      identity: 'itajaisc',
      connection: 'ItajaiSC',
    },
    {
      name: 'Sorocaba - SP',
      identity: 'sorocabasp',
      connection: 'SorocabaSP',
    },
    {
      name: 'Massaranduba - SC',
      identity: 'massarandubasc',
      connection: 'MassarandubaSC',
    },
    {
      name: 'Lages - SC',
      identity: 'lagessc',
      connection: 'LagesSC',
    },
    {
      name: 'Santana de Parnaíba - SP',
      identity: 'santanadeparnaibasp',
      connection: 'SantanadeparnaibaSP',
    },
    {
      name: 'Presidente Prudente - SP',
      identity: 'presidenteprudentesp',
      connection: 'OneDocPresidentePrudente',
    },
    {
      name: 'Bauru - SP',
      identity: 'baurusp',
      connection: 'BauruSP',
    },
    {
      name: 'Jaboticabal - SP',
      identity: 'jaboticabalsp',
      connection: 'JaboticabalSP',
    },
    {
      name: 'Caçador - SC',
      identity: 'cacadorsc',
      connection: 'CacadorSC',
    },
    {
      name: 'IPC - PR',
      identity: 'ipcpr',
      connection: 'IpcPR',
    },
    {
      name: 'Campo Mourão - PR',
      identity: 'campomouraopr',
      connection: 'CampomouraoPR',
    },
    {
      name: 'Poc - AD',
      identity: 'pocad',
      connection: 'PocAD',
    },
    {
      name: 'Urupema - SC',
      identity: 'urupemasc',
      connection: 'UrupemaSC',
    },
    {
      name: 'Valparaíso - GO',
      identity: 'valparaisogo',
      connection: 'ValparaisoGO',
    },
    {
      name: 'Demo - AD',
      identity: 'demoad',
      connection: 'DemoAD',
    },
    {
      name: 'Varginha - MG',
      identity: 'varginhamg',
      connection: 'VarginhaMG',
    },
    {
      name: 'Bertioga - SP',
      identity: 'bertiogasp',
      connection: 'BertiogaSP',
    },
    {
      name: 'Patos de Minas - MG',
      identity: 'patosdeminasmg',
      connection: 'PatosDeMinasMG',
    },
    {
      name: 'Implantação - AD',
      identity: 'implantacaoad',
      connection: 'ImplantacaoAD',
    },
    {
      name: 'Aprovadesk - AD',
      identity: 'aprovadeskad',
      connection: 'AprovadeskAD',
    },
    {
      name: 'Criciúma - SC',
      identity: 'criciumasc',
      connection: 'CriciumaSC',
    },
    {
      name: 'Gaspar - SC',
      identity: 'gasparsc',
      connection: 'GasparSC',
    },
    {
      name: 'Indaial - SC',
      identity: 'indaialsc',
      connection: 'IndaialSC',
    },
    {
      name: 'CIMVI - SC',
      identity: 'cimvisc',
      connection: 'CimviSC',
    },
    {
      name: 'Cajamar - SP',
      identity: 'cajamarsp',
      connection: 'CajamarSP',
    },
    {
      name: 'Marechal Cândido Rondon - PR',
      identity: 'marechalcandidorondonpr',
      connection: 'IpmMarechalCandidoRondon',
    },
    {
      name: 'Franca - SP',
      identity: 'francasp',
      connection: 'FrancaSP',
    },
    {
      name: 'Três Lagoas - MS',
      identity: 'treslagoasms',
      connection: 'TreslagoasMS',
    },
    {
      name: 'São José do Rio Preto - SP',
      identity: 'saojosedoriopretosp',
      connection: 'SaoJoseDoRioPretoSP',
    },
    {
      name: 'Florianópolis - SC',
      identity: 'florianopolissc',
      connection: 'FlorianopolisSC',
    },
    {
      name: 'Condomínios - AD',
      identity: 'condominiosad',
      connection: 'CondominiosAD',
    },
    {
      name: 'Chapecó RH - SC',
      identity: 'chapeco-rhsc',
      connection: 'ChapecoRH',
    },
    {
      name: 'Conselheiro Lafaiete - MG',
      identity: 'conselheirolafaietemg',
      connection: 'ConselheirolafaieteMG',
    },
    {
      name: 'Navegantes - SC',
      identity: 'navegantessc',
      connection: 'NavegantesSC',
    },
    {
      name: 'Goiatuba - GO',
      identity: 'goiatubago',
      connection: 'GoiatubaGO',
    },
    {
      name: 'Santa Luzia - MG',
      identity: 'santaluziamg',
      connection: 'SantaLuziaMG',
    },
    {
      name: 'Guararema - SP',
      identity: 'guararemasp',
      connection: 'GuararemaSP',
    },
    {
      name: 'João Pessoa - PB',
      identity: 'joaopessoapb',
      connection: 'JoaoPessoaPB',
    },
    {
      name: 'Joaçaba - SC',
      identity: 'joacabasc',
      connection: 'JoacabaSC',
    },
    {
      name: 'Prudentópolis - PR',
      identity: 'prudentopolispr',
      connection: 'PrudentopolisPR',
    },
    {
      name: 'Canoinhas - SC',
      identity: 'canoinhassc',
      connection: 'CanoinhasSC',
    },
    {
      name: 'Lençóis Paulista - SP',
      identity: 'lencoispaulistasp',
      connection: 'LencoispaulistaSP',
    },
    {
      name: 'Santa Cruz do Sul - RS',
      identity: 'santacruzdosulrs',
      connection: 'SantacruzdosulRS',
    },
    {
      name: 'Palmeiras de Goiás - GO',
      identity: 'palmeirasdegoiasgo',
      connection: 'PalmeirasdegoiasGO',
    },
    {
      name: 'Palmeira - SC',
      identity: 'palmeirasc',
      connection: 'PalmeiraSC',
    },
    {
      name: 'Lavras - MG',
      identity: 'lavrasmg',
      connection: 'LavrasMG',
    },
    {
      name: 'Procon Chapecó - SC',
      identity: 'proconchapecosc',
      connection: 'ProconchapecoSC',
    },
    {
      name: 'Lagoa Santa - MG',
      identity: 'lagoasantamg',
      connection: 'LagoasantaMG',
    },
    {
      name: 'Volta Redonda - RJ',
      identity: 'voltaredondarj',
      connection: 'VoltaredondaRJ',
    },
    {
      name: 'Altaneira - CE',
      identity: 'altaneirace',
      connection: 'AltaneiraCE',
    },
    {
      name: 'Ouro Verde - SC',
      identity: 'ouroverdesc',
      connection: 'OuroVerdeSC',
    },
    {
      name: 'Câmara Municipal de Caçaador - SC',
      identity: 'cmcacadorsc',
      connection: 'CamaraMunicipalDeCacadorSC',
    },
    {
      name: 'Irani - SC',
      identity: 'iranisc',
      connection: 'IraniSC',
    },
    {
      name: 'Homologação - AD',
      identity: 'homologacaoad',
      connection: 'HomologacaoAD',
    },
    {
      name: 'CM Florianópolis - SC',
      identity: 'cmflorianopolissc',
      connection: 'CMFlorianopolisSC',
    },
    {
      name: 'Abelardo Luz - SC',
      identity: 'abelardoluzsc',
      connection: 'AbelardoLuzSC',
    },
    {
      name: 'Companhia Águas De Itapema - SC',
      identity: 'companhiaaguasdeitapemasc',
      connection: 'CompanhiaAguasDeItapemaSC',
    },
    {
      name: 'Campo Belo - MG',
      identity: 'campobelomg',
      connection: 'CampoBeloMG',
    },
    {
      name: 'Processo Seletivo - AD',
      identity: 'processoseletivoad',
      connection: 'ProcessoSeletivoAD',
    },
    {
      name: 'Muriaé - MG',
      identity: 'muriaemg',
      connection: 'MuriaeMG',
    },
    {
      name: 'Timbó Grande - SC',
      identity: 'timbograndesc',
      connection: 'TimboGrandeSC',
    },
    {
      name: 'Cabreúva - SP',
      identity: 'cabreuvasp',
      connection: 'CabreuvaSP',
    },
    {
      name: 'Dilermando de Aguiar - RS',
      identity: 'dilermandodeaguiarrs',
      connection: 'DilermandoDeAguiarRS',
    },
    {
      name: 'Itanhaém - SP',
      identity: 'itanhaemsp',
      connection: 'ItanhaemSP',
    },
    {
      name: 'Demopoa - RS',
      identity: 'demopoars',
      connection: 'DemopoaRS',
    },
    {
      name: 'Corupá - SC',
      identity: 'corupasc',
      connection: 'CorupaSC',
    },
    {
      name: 'Guaíra - SP',
      identity: 'guairasp',
      connection: 'GuairaSP',
    },
    {
      name: 'Marau - RS',
      identity: 'maraurs',
      connection: 'MarauRS',
    },
    {
      name: 'Agronômica - SC',
      identity: 'agronomicasc',
      connection: 'AgronomicaSC',
    },
    {
      name: 'Santa Rita Do Passa Quatro - SP',
      identity: 'santaritadopassaquatrosp',
      connection: 'SantaRitaDoPassaQuatroSP',
    },
    {
      name: 'Câmara - AD',
      identity: 'camaraad',
      connection: 'CamaraAD',
    },
    {
      name: 'São Francisco Do Sul - SC',
      identity: 'saofranciscodosulsc',
      connection: 'SaoFranciscoDoSulSC',
    },
    {
      name: 'Veranópolis - RS',
      identity: 'veranopolisrs',
      connection: 'VeranopolisRS',
    },
    {
      name: 'Canaã dos Carajás - PA',
      identity: 'canaadoscarajaspa',
      connection: 'CanaaDosCarajasPA',
    },
    {
      name: 'Ponte Nova - MG',
      identity: 'pontenovamg',
      connection: 'PonteNovaMG',
    },
    {
      name: 'Chapecó DGP - SC',
      identity: 'chapeco-dgpsc',
      connection: 'ChapecoDGPSC',
    },
    {
      name: 'Demo P - SP',
      identity: 'demopsp',
      connection: 'DemoPSP',
    },
    {
      name: 'Demo Goiânia - GO',
      identity: 'demogoianiago',
      connection: 'DemoGoianiaGO',
    },
    {
      name: 'Blumenau - SC',
      identity: 'blumenausc',
      connection: 'BlumenauSC',
      loginUrl:
        'https://processodigital.blumenau.sc.gov.br/i4iFlowPMB/login.aspx?0,APROVADIGITAL',
    },
    {
      name: 'POC1 - AD',
      identity: 'poc1ad',
      connection: 'POC1AD',
    },
    {
      name: 'POC2 - AD',
      identity: 'poc2ad',
      connection: 'POC2AD',
    },
    {
      name: 'POC3 - AD',
      identity: 'poc3ad',
      connection: 'POC3AD',
    },
    {
      name: 'Piratininga - SP',
      identity: 'piratiningasp',
      connection: 'PiratiningaSP',
    },
    {
      name: 'Barbacena - MG',
      identity: 'barbacenamg',
      connection: 'BarbacenaMG',
    },
    {
      name: 'Cambuí - MG',
      identity: 'cambuimg',
      connection: 'CambuiMG',
    },
    {
      name: 'Carmo Do Paranaíba - MG',
      identity: 'carmodoparanaibamg',
      connection: 'CarmoDoParanaibaMG',
    },
    {
      name: 'Piranga - MG',
      identity: 'pirangamg',
      connection: 'PirangaMG',
    },
    {
      name: 'Itaquaquecetuba - SP',
      identity: 'itaquaquecetubasp',
      connection: 'ItaquaquecetubaSP',
    },
    {
      name: 'Xaxim - SC',
      identity: 'xaximsc',
      connection: 'XaximSC',
    },
    {
      name: 'Cruz Alta - RS',
      identity: 'cruzaltars',
      connection: 'CruzAltaRS',
    },
    {
      name: 'Três Coracões - MG',
      identity: 'trescoracoesmg',
      connection: 'TresCoracoesMG',
    },
    {
      name: 'São João do Triunfo - PR',
      identity: 'saojoaodotriunfopr',
      connection: 'SaoJoaoDoTriunfoPR',
    },
    {
      name: 'Tatuí - SP',
      identity: 'tatuisp',
      connection: 'TatuiSP',
    },
    {
      name: 'Medianeira - PR',
      identity: 'medianeirapr',
      connection: 'MedianeiraPR',
    },
    {
      name: 'Produto - AD',
      identity: 'produtoad',
      connection: 'ProdutoAD',
    },
    {
      name: 'Votorantim - SP',
      identity: 'votorantimsp',
      connection: 'VotorantimSP',
    },
    {
      name: 'Frederico Westphalen - RS',
      identity: 'fredericowestphalenrs',
      connection: 'FredericoWestphalenRS',
    },
    {
      name: 'Balneário Camboriú - SC',
      identity: 'balneariocamboriusc',
      connection: 'BalnearioCamboriuSC',
    },
    {
      name: 'Demo Cliente - AD',
      identity: 'democlientead',
      connection: 'DemoClienteAD',
    },
    {
      name: 'Oportunidades - AD',
      identity: 'oportunidadesad',
      connection: 'OportunidadesAD',
    },
    {
      name: 'São Miguel do Oeste - SC',
      identity: 'saomigueldooestesc',
      connection: 'SaoMiguelDoOesteSC',
    },
    {
      name: 'Matão - SP',
      identity: 'mataosp',
      connection: 'MataoSP',
    },
    {
      name: 'Pacatuba - CE',
      identity: 'pacatubace',
      connection: 'PacatubaCE',
    },
    {
      name: 'Ibirubá - RS',
      identity: 'ibirubars',
      connection: 'IbirubaRS',
    },
    {
      name: 'Venâncio Aires - RS',
      identity: 'venancioairesrs',
      connection: 'VenancioAiresRS',
    },
    {
      name: 'Sao José dos Pinhais - PR',
      identity: 'saojosedospinhaispr',
      connection: 'SaoJoseDosPinhaisPR',
    },
    {
      name: 'Montes Claros - MG',
      identity: 'montesclarosmg',
      connection: 'MontesClarosMG',
    },
    {
      name: 'Mogi Guaçu - SP',
      identity: 'mogiguacusp',
      connection: 'MogiGuacuSP',
    },
    {
      name: 'Gravatá - PE',
      identity: 'gravatape',
      connection: 'GravataPE',
    },
    {
      name: 'Inema - BA',
      identity: 'inemabaad',
      connection: 'InemabaAD',
    },
    {
      name: 'BB - AD',
      identity: 'bbad',
      connection: 'BBAD',
    },
    {
      name: 'Cambé - PR',
      identity: 'cambepr',
      connection: 'CambePR',
    },
    {
      name: 'Ariquemes - RO',
      identity: 'ariquemesro',
      connection: 'AriquemesRO',
    },
    {
      name: 'Londrina - PR',
      identity: 'londrinapr',
      connection: 'LondrinaPR',
    },
    {
      name: 'Cohab Campinas - SP',
      identity: 'cohabcampinassp',
      connection: 'CohabCampinasSP',
    },
    {
      name: 'Santiago - RS',
      identity: 'santiagors',
      connection: 'SantiagoRS',
    },
    {
      name: 'CimviVS - SC',
      identity: 'consorciocimvisc',
      connection: 'ConsorcioCimviSC',
    },
    {
      name: 'Paulista - PE',
      identity: 'paulistape',
      connection: 'PaulistaPE',
    },
    {
      name: 'Explore - AD',
      identity: 'exploread',
      connection: 'ExploreAD',
    },
    {
      name: 'São Gotardo - MG',
      identity: 'saogotardomg',
      connection: 'SaoGotardoMG',
    },
    {
      name: 'São Gonçalo do Rio Abaixo - MG',
      identity: 'saogoncalodorioabaixomg',
      connection: 'SaoGoncaloDoRioAbaixoMG',
    },
    {
      name: 'Naviraí - MS',
      identity: 'naviraims',
      connection: 'NaviraiMS',
    },
    {
      name: 'São Pedro - SP',
      identity: 'saopedrosp',
      connection: 'SaoPedroSP',
    },
    {
      name: 'Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome - BR',
      identity: 'paa-mdsbr',
      connection: 'PaaMdsBR',
    },
    {
      name: 'SandBox - AD',
      identity: 'sandboxad',
      connection: 'SandboxAD',
    },
    {
      name: 'SandBox2 - AD',
      identity: 'sandbox2ad',
      connection: 'Sandbox2AD',
    },
    {
      name: 'SandBox3 - AD',
      identity: 'sandbox3ad',
      connection: 'Sandbox3AD',
    },
    {
      name: 'Dourados - MS',
      identity: 'douradosms',
      connection: 'DouradosMS',
    },
    {
      name: 'Não-Me-Toque - RS',
      identity: 'naometoquers',
      connection: 'NaoMeToqueRS',
    },
    {
      name: 'Bragança - PA',
      identity: 'bragancapa',
      connection: 'BragancaPA',
    },
    {
      name: 'Taió - SC',
      identity: 'taiosc',
      connection: 'TaioSC',
    },
    {
      name: 'Tapauá - AM',
      identity: 'tapauaam',
      connection: 'TapauaAM',
    },
    {
      name: 'Ouro Branco - MG',
      identity: 'ourobrancomg',
      connection: 'OuroBrancoMG',
    },
    {
      name: 'COHAVEL - PR',
      identity: 'cohavelpr',
      connection: 'CohavelPR',
    },
    {
      name: 'Itu - SP',
      identity: 'itusp',
      connection: 'ItuSP',
    },
    {
      name: 'Espumoso - RS',
      identity: 'espumosors',
      connection: 'EspumosoRS',
    },
    {
      name: 'São Carlos - SP',
      identity: 'saocarlossp',
      connection: 'SaoCarlosSP',
    },
    {
      name: 'Aracruz - ES',
      identity: 'aracruzes',
      connection: 'AracruzES',
    },
    {
      name: 'Canoas - RS',
      identity: 'canoasrs',
      connection: 'CanoasRS',
    },
    {
      name: 'Herculândia - SP',
      identity: 'herculandiasp',
      connection: 'HerculandiaSP',
    },
    {
      name: 'Cabo Frio - RJ',
      identity: 'cabofriorj',
      connection: 'CabofrioRJ',
    },
    {
      name: 'Magé - RJ',
      identity: 'magerj',
      connection: 'MageRJ',
    },
    {
      name: 'Cafelândia - PR',
      identity: 'cafelandiapr',
      connection: 'CafelandiaPR',
    },
    {
      name: 'São Pedro do Paraná - PR',
      identity: 'saopedrodoparanapr',
      connection: 'SaopedrodoparanaPR',
    },
    {
      name: 'CIM Guandu - ES',
      identity: 'cimguandues',
      connection: 'CimguanduES',
    },
    {
      name: 'Passa Quatro - MG',
      identity: 'passaquatromg',
      connection: 'PassaquatroMG',
    },
    {
      name: 'Ipatinga - MG',
      identity: 'ipatingamg',
      connection: 'IpatingaMG',
    },
    {
      name: 'Rio Grande - RS',
      identity: 'riogranders',
      connection: 'RiograndeRS',
    },
    {
      name: 'São José - SC',
      identity: 'saojosesc',
      connection: 'SaojoseSC',
    },
    {
      name: 'Formiga - MG',
      identity: 'formigamg',
      connection: 'FormigaMG',
    },
    {
      name: 'Brasilândia - MS',
      identity: 'brasilandiams',
      connection: 'BrasilandiaMS',
    },
    {
      name: 'Araxá - MG',
      identity: 'araxamg',
      connection: 'AraxaMG',
    },
    {
      name: 'Mimoso do Sul - ES',
      identity: 'mimosodosules',
      connection: 'MimosoDoSulES',
    },
    {
      name: 'Ribeirão Preto - SP',
      identity: 'ribeiraopretosp',
      connection: 'RibeiraoPretoSP',
    },
    {
      name: 'Monte Sião - MG',
      identity: 'montesiaomg',
      connection: 'MonteSiaoMG',
    },
    {
      name: 'SandBox4 - AD',
      identity: 'sandbox4ad',
      connection: 'Sandbox4AD',
    },
    {
      name: 'Rio das Ostras - RJ',
      identity: 'riodasostrasrj',
      connection: 'RioDasOstrasRJ',
    },
    {
      name: 'Umuarama - PR',
      identity: 'umuaramapr',
      connection: 'UmuaramaPR',
    },
    {
      name: 'Buriti Alegre - GO',
      identity: 'buritialegrego',
      connection: 'BuritiAlegreGO',
    },
    {
      name: 'Tibagi - PR',
      identity: 'tibagipr',
      connection: 'TibagiPR',
    },
    {
      name: 'Uberaba - MG',
      identity: 'uberabamg',
      connection: 'UberabaMG',
    },
    {
      name: 'Sandbox5 - AD',
      identity: 'sandbox5ad',
      connection: 'Sandbox5AD',
    },
    {
      name: 'Consórcio Brasil Central - GO',
      identity: 'consorciobrasilcentralgo',
      connection: 'ConsorcioBrasilCentralGO',
    },
    {
      name: 'Maringá - PR',
      identity: 'maringapr',
      connection: 'MaringaPR',
    },
    {
      name: 'Dois Irmãos - RS',
      identity: 'doisirmaosrs',
      connection: 'DoisIrmaosRS',
    },
    {
      name: 'Barueri - SP',
      identity: 'baruerisp',
      connection: 'BarueriSP',
    },
    {
      name: 'Marabá - PA',
      identity: 'marabapa',
      connection: 'MarabaPA',
    },
    {
      name: 'Cristalina - GO',
      identity: 'cristalinago',
      connection: 'CristalinaGO',
    },
    {
      name: 'Pouso Redondo - SC',
      identity: 'pousoredondosc',
      connection: 'PousoRedondoSC',
    },
    {
      name: 'Toledo - PR',
      identity: 'toledopr',
      connection: 'ToledoPR',
    },
    {
      name: 'Niterói - RJ',
      identity: 'niteroirj',
      connection: 'NiteroiRJ',
    },
    {
      name: 'Saquarema - RJ',
      identity: 'saquaremarj',
      connection: 'SaquaremaRJ',
    },
    {
      name: 'Guapiaçu - SP',
      identity: 'guapiacusp',
      connection: 'GuapiacuSP',
    },
    {
      name: 'Cláudia - MT',
      identity: 'claudiamt',
      connection: 'ClaudiaMT',
    },
    {
      name: 'Cachoeira de Minas - MG',
      identity: 'cachoeirademinasmg',
      connection: 'CachoeiraDeMinasMG',
    },
    {
      name: 'Sandbox6 - AD',
      identity: 'sandbox6ad',
      connection: 'Sandbox6AD',
    },
    {
      name: 'Porto Rico - PR',
      identity: 'portoricopr',
      connection: 'PortoRicoPR',
    },
  ];

  authenticationUrl = {
    v1: 'https://api.producao.aprova.com.br/authentication-api/v1',
  };

  citiesUrl = {
    v1: 'https://api.producao.aprova.com.br/cities',
  };

  usersUrl = {
    v2: 'https://api.producao.aprova.com.br/users/v2',
  };

  integrationsUrl = {
    v1: 'https://api.producao.aprova.com.br/integracoes-externas',
  };

  recaptcha = {
    siteKey: '6Les3sEUAAAAAEw59z-wAQOt8no3d500fFYdbLf0',
  };

  webpki = {
    apiKey:
      'AjsAKi5hcHJvdmEuY29tLmJyLCouYmJnb3Zlcm5vZGlnaXRhbC5jb20uYnIsKi5wcmVmZWl0dXJhcy5uZXRDAGlwNDoxMC4wLjAuMC84LGlwNDoxMjcuMC4wLjAvOCxpcDQ6MTcyLjE2LjAuMC8xMixpcDQ6MTkyLjE2OC4wLjAvMTYDAFBybwAAAAFIHZy7hX+Zt6sZlFtXYbaKc/fx7G3OaoGd8hhAljlcRRxSzCcUUpCAQGQg0E8emV0Et5wpaRokzxT7fh5dy286V141zARwvqRqhRh0k02kw5QRQf+f9/Oqb9ZsmPPcJIaCOPlPvqDKPIBW4aSdOZO8GVa+hphopQ9RDt0H9ZYjV0awgtzt2yRkonnL6tImFXUh6VMxGbtiCGGnEK0mTMdib8uzS4FbaYitVI7HzmySvo/M179bpH9a+qJz3UthF+cR3mAy7/t/rRUdpGyr06TsEE8uLRCtXKK9ZgKCbhDZEuc+IyBgTxDtSx4tq08EIu2XvH6JpYEBKwZuEWMQXCoC',
    pluginUrl:
      'https://chrome.google.com/webstore/detail/web-pki/dcngeagmmhegagicpcmpinaoklddcgon',
  };


  socialLogin = {
    google: {
      clientId:
        '151302971136-2qvflstuuqpe3j2f865bsrgh7cvjev02.apps.googleusercontent.com',
    },
  };

  intercom = {
    appId: 'ln2pzt2w',
  };
}
